var map = {
	"./experiences/datascientest.png": "efe3",
	"./experiences/doctolib.png": "7454",
	"./experiences/iwd.png": "dd3c",
	"./experiences/yoopies.png": "7633",
	"./projects/alix.png": "9226",
	"./projects/elevator.png": "5d26",
	"./projects/hikeero.jpg": "d3e9",
	"./projects/react.png": "8d43",
	"./projects/teyvat.png": "fee7",
	"./projects/website.png": "76df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a3f8";